import createReactComponent from '../createReactComponent';
var RotateCcw = createReactComponent('RotateCcw', [['path', {
  d: 'M3 2v6h6',
  key: '18ldww'
}], ['path', {
  d: 'M3 13a9 9 0 103-7.7L3 8',
  key: '3uqywx'
}]]);
export default RotateCcw;